// extracted by mini-css-extract-plugin
export var chevron = "_im-2";
export var dropdownItems = "_im-0";
export var item = "_im-1";